import { handleActions } from 'redux-actions';
import {
  setApplicantList,
  fetchApplicantList,
  setApplicantError,
  setApplicantFilters,
  toggleCheckedApplicants,
  uncheckAllApplicants,
  setApplicantStageId,
  setProgramId,
} from './actions';

const defaultState = {
  loading: false,
  checkedApplicantIds: [],
  filters: {
    pageNumber: 1,
    pageSize: 10,
    sortBy: '',
    search: '',
    programId: null,
    applicantStageId: null,
    isSortOrderDescending: false,
    status: null,
  },
  totalRecords: 0,
  data: [],
  options: [],
  error: null,
};

export default handleActions(
  {
    [fetchApplicantList](state) {
      return {
        ...state,
        loading: true,
        data: [],
      };
    },
    [setApplicantList](state, { payload }) {
      return {
        ...state,
        loading: false,
        data: payload.data.records,
        totalRecords: payload.data.totalRecords,
        error: null,
      };
    },
    [setApplicantError](state, { payload }) {
      return {
        ...state,
        data: [],
        loading: false,
        totalPages: defaultState.totalPages,
        error: payload?.message,
      };
    },
    [setApplicantStageId](state, { payload }) {
      return {
        ...state,
        filters: {
          ...state.filters,
          applicantStageId: payload,
        },
      };
    },
    [setProgramId](state, { payload }) {
      return {
        ...state,
        filters: {
          ...state.filters,
          programId: payload,
        },
      };
    },
    [setApplicantFilters](state, { payload }) {
      return {
        ...state,
        filters: {
          ...state.filters,
          programId: null,
          applicantStageId: null,
          ...payload,
        },
        checkedApplicantIds: [],
      };
    },
    [toggleCheckedApplicants](state, { payload: applicantId }) {
      const checkedIds = state.checkedApplicantIds;
      return {
        ...state,
        checkedApplicantIds: checkedIds.includes(applicantId)
          ? checkedIds.filter((id) => id !== applicantId)
          : [...checkedIds, applicantId],
      };
    },
    [uncheckAllApplicants](state) {
      return {
        ...state,
        checkedApplicantIds: [],
      };
    },
  },
  defaultState,
);
